/**
 * KPICard — card de indicador (Distância, Vel. Média, Consumo, Operação...).
 * Extraído de EquipmentMonitorPage.js para reuso entre a tela e a página de PDF.
 */
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export const KPIValue = ({ value, unit, className = 'text-lg font-semibold text-foreground' }) => (
  <span className={className}>
    {value !== null && value !== undefined ? (
      <>
        {typeof value === 'number' ? value.toFixed(1) : value}
        <span className="text-sm text-muted-foreground ml-1">{unit}</span>
      </>
    ) : (
      <span className="text-muted-foreground">—</span>
    )}
  </span>
);

export const KPICard = ({ icon: Icon, label, value, unit, loading, error, secondaryItems = [] }) => (
  <Card className="bg-card border-border">
    <CardContent className="p-4">
      <div className="flex items-start gap-3">
        <div className="p-2 rounded-lg bg-primary/10">
          <Icon className="h-5 w-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs text-muted-foreground truncate">{label}</p>
          {loading ? (
            <Skeleton className="h-6 w-16 mt-1" />
          ) : error ? (
            <p className="text-sm text-destructive">—</p>
          ) : (
            <>
              <p>
                <KPIValue value={value} unit={unit} />
              </p>
              {secondaryItems.length > 0 && (
                <div className="mt-1 space-y-0.5">
                  {secondaryItems.map(item => (
                    <div key={item.label} className="flex items-baseline justify-between gap-2 text-xs">
                      <span className="text-muted-foreground truncate">{item.label}</span>
                      <KPIValue
                        value={item.value}
                        unit={item.unit}
                        className="text-xs font-medium text-foreground whitespace-nowrap"
                      />
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </CardContent>
  </Card>
);

export default KPICard;
